<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_re9"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('shipperReview_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('shipperReview_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-hover-row
      row-id="id"
      height="80%"
      highlight-current-row
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      show-footer
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          :filter-multiple="false"
          :formatter="formatterAuthStatus"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authMsg"
          title="驳回原因"
          show-header-overflow
          show-overflow
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.authMsg"
            placeholder="驳回原因"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="托运人姓名"
          show-header-overflow
          show-overflow
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="托运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          show-header-overflow
          show-overflow
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="公司名称"
          show-header-overflow
          show-overflow
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="staffType"
          title="托运人类型"
          :filter-multiple="false"
          :formatter="formatterStaffType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.staffTypes" placeholder="请选择">
            <el-option
              v-for="item in staffTypeOptions2"
              :key="item.value"
              :label="item.label"
              :value="item.value + ''"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxPoint"
          title="服务费率(%)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPointStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPointEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="verifyCompany"
          title="企业验证通过"
          :formatter="formatterVerifyCompany"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.verifyCompany"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in verifyCompanyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="isIndependentCheckout"
          title="是否独立核算"
          :formatter="formatterCommonStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isIndependentCheckout"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in commonStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 创建时间 -->
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <!-- 审核时间 -->
      <vxe-table-column>
        <vxe-table-column
          field="authTime"
          title="审核时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.authTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('shipperReview_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('shipperReview_audit_button') &&
                scope.row.authStatus != 2 &&
                scope.row.authStatus != 3
            "
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button type="text" @click="funcRiview(scope.row)">
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- 详情 -->
    <vxe-modal
      v-model="shipperDetail"
      title="详情"
      width="1200"
      height="680"
      resize
    >
      <shipperDetail ref="detailRef" :parent-data="parentData" />
    </vxe-modal>
    <!-- 审核 -->
    <vxe-modal
      v-model="shipperReview"
      title="审核"
      width="1200"
      height="760"
      resize
    >
      <shipperForm
        v-if="shipperReview"
        ref="reviewRef"
        :parent-data="parentData"
        @fatherMethods="fatherMethods"
      />
    </vxe-modal>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import shipperDetail from "./components/shipperDetail.vue";
import shipperForm from "./components/shipperForm.vue";
import { getShipperList } from "@/api/shipment";
import { getRole } from "@/utils/getRole";
export default {
  name: "ShipmentList",
  components: {
    shipperDetail,
    shipperForm
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/shipment/exportShipmentAuth", //导出接口
        name: "托运人审核"
      },
      isCtms: true, //默认显示  同城系统隐藏
      parentData: {
        isDetail: true,
        areaOptions: this.$store.state.components.areaOptions,
        receiverUserCodeOptions: [],
        typeOptions: [],
        bankOptions: []
      },

      loading: false,
      tableData: [],
      shipperDetail: false,
      shipperReview: false,
      listQuery: {
        gmtCreatedRange: "",
        authTimeRange: "",
        userName: "", // 用户名
        phone: "", // 手机号
        companyName: "", // 公司名称
        freezingAmount: "", // 冻结金额
        amount: "", // 账户金额
        taxPoint: "", // 税点
        authStatus: "", // 审核状态：0未审核/1审核中/2审核未通过/3审核通过
        excludeOnboardingPending: true, // 排除入驻流程未完成风控审核的货主
        gmtCreatedStart: "", // 创建时间起始
        gmtCreatedEnd: "", // 创建时间终止
        authTimeStart: "", // 审核时间开始
        authTimeEnd: "", // 审核时间结束
        isIndependentCheckout: "", // 是否独立核算:0否/1是
        verifyCompany: "", // 企业是否验证通过:0否/1是
        staffTypes: "1,0", // 角色，0-个体托运人，1-企业托运人，2-企业发货联系人，3-企业财务，4-企业卸货联系人，5-上游客户，6-代付机构
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        exportType: 2,
        authMsg: ""
      },
      sumObject: {
        amount: 0
      },
      // 审核状态
      authStatusOptions: [
        {
          label: "未审核",
          value: 0
        },
        // {
        //   label: "审核中",
        //   value: 1
        // },
        {
          label: "审核驳回",
          value: 2
        },
        {
          label: "审核通过",
          value: 3
        }
      ],

      // 托运人类型
      staffTypeOptions2: [
        {
          label: "个体托运人",
          value: 0
        },
        {
          label: "企业托运人",
          value: 1
        },
        {
          label: "全部",
          value: "1,0"
        }
      ],
      // 托运人类型
      staffTypeOptions: [
        {
          label: "个体托运人",
          value: 0
        },
        {
          label: "企业托运人",
          value: 1
        },
        {
          label: "企业发货联系人",
          value: 2
        },
        {
          label: "企业财务",
          value: 3
        },
        {
          label: "企业卸货联系人",
          value: 4
        },
        {
          label: "上游客户",
          value: 5
        },
        {
          label: "代付机构",
          value: 6
        }
      ],
      // 企业三要素状态
      verifyCompanyOptions: [
        {
          label: "未审核",
          value: 2
        },
        {
          label: "未通过",
          value: 0
        },
        {
          label: "通过",
          value: 1
        }
      ],
      // 通用是否状态
      commonStatusOptions: [
        {
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo;
      if (v) {
        this.listQuery.authStatus = 0;
      } else {
        this.listQuery.authStatus = "";
      }
      this.findList();
    }
  },
  created() {
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.authStatus = 0;
    }
    this.findList();
    let isCtmsShow = getRole(); //获取登录用户登录的是否是同城系统
    this.isCtms = !isCtmsShow;
  },
  methods: {
    // 托运人类型
    formatterStaffType({ cellValue }) {
      const item = this.staffTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 获取列表
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getShipperList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 获取详情
    funcDetail(code) {
      this.$refs.detailRef.getShipperDetail(code);
      this.shipperDetail = true;
    },
    // 审核
    funcRiview(code) {
      this.shipperReview = true;
      this.$nextTick(() => {
        this.$refs.reviewRef.getShipperDetail(code);
      });
    },
    // 关闭审核弹窗
    fatherMethods() {
      this.shipperReview = !this.shipperReview;
      this.findList();
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译企业三要素状态
    formatterVerifyCompany({ cellValue }) {
      const item = this.verifyCompanyOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译通用是否状态
    formatterCommonStatus({ cellValue }) {
      const item = this.commonStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "amount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
